import React from 'react';
import { Icon } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import * as S from './RemovableUpload.styled';
export const RemovableUpload = ({ children, withBackground = true, onRemove }) => (React.createElement(S.Container, { withBackground: withBackground },
    React.createElement(S.Button, { type: "button", onClick: onRemove },
        React.createElement(S.ButtonBackground, null),
        React.createElement(Icon, { component: CloseIcon, height: 12 })),
    children));
